import BankConnectionProviderIcon from "./BankConnectionProviderIcon";
import type { BankConnectionProvider } from "../bankConnectionProvider";
import { isLinkedBankConnectionProvider } from "../bankConnectionProvider";

interface BankInstitutionCellProps {
  bankName?: string | null;
  bankConnectionProvider?: BankConnectionProvider | null;
}

export default function BankInstitutionCell({ bankName, bankConnectionProvider }: BankInstitutionCellProps) {
  const showProviderIcon = bankConnectionProvider && isLinkedBankConnectionProvider(bankConnectionProvider);

  return (
    <div className="flex items-center gap-2">
      {showProviderIcon && <BankConnectionProviderIcon provider={bankConnectionProvider} />}
      <span>{bankName || <span className="opacity-20">--</span>}</span>
    </div>
  );
}
